module.exports = __webpack_public_path__ + "img/register.37562a9f.svg";